<div class="flex h-full w-full flex-row items-center justify-center">
  <div
    *ngIf="qData.length > 0 && !!yFieldColumn"
    class="text-s500 text-3xl font-semibold"
  >
    {{ qData[0][yFieldColumn.id].valueFmt }}
  </div>

  <!-- <div
    *ngIf="qData.length > 0 && !!yFieldColumn"
    class="text-s500 text-3xl font-semibold"
  >
    {{
      isFormat === true
        ? qData[0][yFieldColumn.id].valueFmt
        : qData[0][yFieldColumn.id].value
    }}
  </div> -->
</div>
